/* eslint-disable camelcase */
import {
    SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS,
    SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE,
    SET_CONSIGNMENT_ADD_CU_IN_PROGRESS,
    SET_CONSIGNMENT_ADD_ORDER_SUBMITTED,
} from '../actions/actionTypes';

import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* saveconsignmentAdd(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/consignment/consignmentAdd`;

    const payload = removeEmptyFieldsFromObject(action.payload);
    const isconsignmentAddOrderSubmitted = action.payload.isSAPSubmission;

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);
        // const result = yield saveconsignmentAddDataService(payload);
        // if (result.statusCode == RESPONSESUCCESS) {
        const modify_result = {
            ...result,
            isSubmitted: action.payload.isSubmitted,
        };
        yield put({
            type: SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS,
            data: modify_result,
        });
        !Object.prototype.hasOwnProperty.call(result, 'excludedProducts') ||
        result.excludedProducts.length == 0
            ? yield put({
                  type: SET_CONSIGNMENT_ADD_ORDER_SUBMITTED,
                  data: isconsignmentAddOrderSubmitted,
              })
            : null;
        yield put({ type: SET_CONSIGNMENT_ADD_CU_IN_PROGRESS, data: false });
        // }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
